import { intersect } from "../../../../common/helpers/ZodHelpers";
import { descriptionSchema } from "./DescriptionSchema";

export const draftProjectValidationSchema = intersect([
    descriptionSchema,
])